import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client"
import LocalStorageService from "../services/localstorage.service";
import { AdType } from "../types/ad";

const client = new HTTPClient()

export interface AdsFilter {
    page: number;
    limit: number;
}

export interface ResponseType {
    ads?: {
        data: Array<AdType>;
    };
    total?: number;
    error?: string;
}

interface CRUDResponse {
    success: boolean;
    error: any;
}

class AdsModel {
    static async find(headerId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
           `${AUTH_URL}/ads/${headerId}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ResponseType
    }

    static async saveAd(data: AdType){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            data.id ? RequestType.PUT : RequestType.POST,
            data.id ? `${AUTH_URL}/ads/${data.id}` : `${AUTH_URL}/ads`,
            JSON.stringify(data),
            auth.accessToken,
        );

        const response =  data.id ? await client.put(request) : await client.post(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as CRUDResponse
    }

    static async delete(itemId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.DELETE,
            `${AUTH_URL}/ads/${itemId}`,
            undefined,
            auth.accessToken,
        );

        const response =  await client.delete(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as CRUDResponse
    }

    static async getAll(filters: AdsFilter){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
            `${AUTH_URL}/ads?page=${filters.page}&limit=${filters.limit}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ResponseType
    }
}

export default AdsModel